// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MembersList Styles */

.members-section {
  /* margin-top: var(--space-3); */
  background: linear-gradient(135deg, #fef9f3 0%, #ece6de 100%);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-lg);
  padding: var(--space-2) var(--space-3);
  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.2);
  transition: all var(--transition-fast);
}

.members-section:hover {
  box-shadow: 0 3px 10px rgba(109, 76, 41, 0.25);
}

.members-header {
  background-color:#e6d1b9;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-primary);
  padding: 0 var(--space-2);
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
}

.members-header--collapsible {
  cursor: pointer;
  padding: var(--space-2);
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
  user-select: none;
}

.members-header--collapsible:hover {
  background: rgba(184, 71, 14, 0.05);
}

.members-toggle-icon {
  margin-left: auto;
  font-size: 10px;
  color: var(--color-fire-600);
  transition: transform var(--transition-fast);
}

.members-toggle-icon--expanded {
  transform: rotate(180deg);
}

.members-icon {
  font-size: 16px;
  line-height: 1;
  filter: sepia(1) hue-rotate(90deg) saturate(2);
}

.members-pending-badge {
  display: flex;
  align-items: center;
  gap: 3px;
  color: var(--color-warning-700);
  font-weight: 600;
  font-size: 12px;
  padding: 2px 6px;
  background: rgba(217, 119, 6, 0.1);
  border-radius: 10px;
  border: 1px solid var(--color-warning-400);
  white-space: nowrap;
}

.members-pending-icon {
  font-size: 12px;
}

.members-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

/* Toggle button for collapsible list */
.members-toggle-btn {
  width: 100%;
  padding: 10px 16px;
  margin-top: var(--space-2);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-fire-700);
  background: linear-gradient(135deg, #fef9f3 0%, #f9f0e6 100%);
  border: 2px solid var(--color-fire-500);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.members-toggle-btn:hover {
  background: linear-gradient(135deg, #f9f0e6 0%, #f5e8dc 100%);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(212, 129, 74, 0.3);
}

.members-toggle-btn--collapse {
  color: var(--color-wood-700);
  border-color: var(--color-wood-500);
  background: linear-gradient(135deg, #f5efe6 0%, #ebe3d6 100%);
}

.members-toggle-btn--collapse:hover {
  background: linear-gradient(135deg, #ebe3d6 0%, #e0d6c6 100%);
  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.3);
}

/* Mobile responsive */
@media (max-width: 425px) {
  .members-header {
    font-size: 11px;
    padding: 0 8px;
    gap: 4px;
  }

  .members-pending-badge {
    font-size: 10px;
  }

  .members-pending-icon {
    font-size: 10px;
  }

  /* .members-list {
    gap: 6px;
  } */

  .members-toggle-btn {
    padding: 8px 12px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/members/MembersList.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,gCAAgC;EAChC,6DAA6D;EAC7D,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,6DAA6D;EAC7D,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;KAEG;;EAEH;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* MembersList Styles */\n\n.members-section {\n  /* margin-top: var(--space-3); */\n  background: linear-gradient(135deg, #fef9f3 0%, #ece6de 100%);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-lg);\n  padding: var(--space-2) var(--space-3);\n  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.2);\n  transition: all var(--transition-fast);\n}\n\n.members-section:hover {\n  box-shadow: 0 3px 10px rgba(109, 76, 41, 0.25);\n}\n\n.members-header {\n  background-color:#e6d1b9;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  padding: 0 var(--space-2);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: nowrap;\n}\n\n.members-header--collapsible {\n  cursor: pointer;\n  padding: var(--space-2);\n  border-radius: var(--radius-md);\n  transition: all var(--transition-fast);\n  user-select: none;\n}\n\n.members-header--collapsible:hover {\n  background: rgba(184, 71, 14, 0.05);\n}\n\n.members-toggle-icon {\n  margin-left: auto;\n  font-size: 10px;\n  color: var(--color-fire-600);\n  transition: transform var(--transition-fast);\n}\n\n.members-toggle-icon--expanded {\n  transform: rotate(180deg);\n}\n\n.members-icon {\n  font-size: 16px;\n  line-height: 1;\n  filter: sepia(1) hue-rotate(90deg) saturate(2);\n}\n\n.members-pending-badge {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  color: var(--color-warning-700);\n  font-weight: 600;\n  font-size: 12px;\n  padding: 2px 6px;\n  background: rgba(217, 119, 6, 0.1);\n  border-radius: 10px;\n  border: 1px solid var(--color-warning-400);\n  white-space: nowrap;\n}\n\n.members-pending-icon {\n  font-size: 12px;\n}\n\n.members-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n/* Toggle button for collapsible list */\n.members-toggle-btn {\n  width: 100%;\n  padding: 10px 16px;\n  margin-top: var(--space-2);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-fire-700);\n  background: linear-gradient(135deg, #fef9f3 0%, #f9f0e6 100%);\n  border: 2px solid var(--color-fire-500);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.members-toggle-btn:hover {\n  background: linear-gradient(135deg, #f9f0e6 0%, #f5e8dc 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(212, 129, 74, 0.3);\n}\n\n.members-toggle-btn--collapse {\n  color: var(--color-wood-700);\n  border-color: var(--color-wood-500);\n  background: linear-gradient(135deg, #f5efe6 0%, #ebe3d6 100%);\n}\n\n.members-toggle-btn--collapse:hover {\n  background: linear-gradient(135deg, #ebe3d6 0%, #e0d6c6 100%);\n  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.3);\n}\n\n/* Mobile responsive */\n@media (max-width: 425px) {\n  .members-header {\n    font-size: 11px;\n    padding: 0 8px;\n    gap: 4px;\n  }\n\n  .members-pending-badge {\n    font-size: 10px;\n  }\n\n  .members-pending-icon {\n    font-size: 10px;\n  }\n\n  /* .members-list {\n    gap: 6px;\n  } */\n\n  .members-toggle-btn {\n    padding: 8px 12px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
